import { ComponentStyleConfig } from '@chakra-ui/react';

export const FormLabel: ComponentStyleConfig = {
	baseStyle: {
		fontSize: 'sm',
		mb: 1,
	},
};
